export const anonymousUser = {
  kind: 'user',
  key: 'anonymous',
  anonymous: true,
};
